import { emailConfirmation } from '@/api'

export type ApiResult<T> = {
  data: T | null
  success: boolean
  error?: string
}

export const sendEmailCode = async (
  userId: number,
  email: string,
): Promise<ApiResult<boolean>> => {
  try {
    const data = new FormData()
    data.append('user_id', String(userId))
    data.append('email', email)
    
    const res = await emailConfirmation.sendEmailCode(data)
    const success = res?.data?.success === true

    return {
      data: success,
      success,
      error: res?.data?.error || res?.data?.message || 'Неизвестная ошибка',
    }
  } catch (error) {
    console.error('Ошибка отправки кода:', error)
    return {
      data: null,
      success: false,
      error: error instanceof Error ? error.message : String(error),
    }
  }
}

export const verifyEmailCode = async (
  userId: number,
  code: string,
): Promise<ApiResult<{ message: string; isChangeEmail: boolean }>> => {
  try {
    const data = new FormData()
    data.append('user_id', String(userId))
    data.append('code', code)

    const res = await emailConfirmation.verifyEmailCode(data)
    const success = res?.data?.success === true || res?.data?.status === 'success' || res?.status === 200

    return {
      data: res?.data?.data || res?.data,
      success,
      error: res?.data?.error || res?.data?.message,
    }
  } catch (error) {
    console.error('Ошибка подтверждения кода:', error)
    return {
      data: null,
      success: false,
      error: error instanceof Error ? error.message : String(error),
    }
  }
}
